/** Firestore collection for שוק הבסטות / local business sellers */
export const LOCAL_BUSINESS_COLLECTION = 'localbusiness';
